import script from "./FifthView.vue?vue&type=script&setup=true&lang=ts"
export * from "./FifthView.vue?vue&type=script&setup=true&lang=ts"

import "./FifthView.vue?vue&type=style&index=0&id=bb2d6c3e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb2d6c3e"]])

export default __exports__